/**
 * PermissionsManager - Master class for permission validations
 * 
 * Centralizes all "can do this" validations based on parameters
 * like loginMode, app configuration, etc.
 */

import { LOGIN_MODE, REGISTER_MODE } from "@lib/constants";
export class PermissionsManager {
  constructor() {}
  static getInstance() {
    if (!PermissionsManager.instance) {
      PermissionsManager.instance = new PermissionsManager();
    }
    return PermissionsManager.instance;
  }

  /**
   * Determines if the allow unauthenticated users is needed
   */
  allowUnauthenticatedUsers() {
    return process.env.NEXT_PUBLIC_ALLOW_UNAUTHENTICATED_USERS === "true";
  }

  /**
   * Determines if the login button can be shown
   */
  canShowLoginButton() {
    const loginMode = process.env.NEXT_PUBLIC_LOGIN_MODE || 'none';
    return loginMode === LOGIN_MODE.FORM || loginMode === LOGIN_MODE.IFRAME;
  }

  /**
   * Determines if the register button can be shown
   */
  showRegisterButton() {
    return process.env.NEXT_PUBLIC_REGISTER_MODE === REGISTER_MODE.PRE_REGISTRATION;
  }

  /**
   * Determines if the entity login data is needed
   */
  useEntityLogin() {
    return process.env.NEXT_PUBLIC_LOGIN_MODE === LOGIN_MODE.IFRAME || process.env.NEXT_PUBLIC_LOGIN_MODE === LOGIN_MODE.TOKEN_PARAMS;
  }

  /**
   * Determines if the register form should be shown
   */
  showRegisterForm() {
    return process.env.NEXT_PUBLIC_REGISTER_MODE === REGISTER_MODE.FULL_REGISTRATION;
  }

  /**
   * Determines if the test errors should be shown in the credit card form
   */
  showTestErrorsInCreditCardForm() {
    return process.env.NEXT_PUBLIC_TEST_DLOCAL_ERRORS === "true";
  }
  showUserEmail() {
    return process.env.NEXT_PUBLIC_SHOW_USER_EMAIL === "true";
  }

  /**
   * GET payment method config
   */
  paymentMethodConfig() {
    const config = {
      showEmail: process.env.NEXT_PUBLIC_PAYMENT_METHOD_SHOW_EMAIL === "true",
      showDocumentNumber: process.env.NEXT_PUBLIC_PAYMENT_METHOD_SHOW_DOCUMENT_NUMBER === "true",
      requiredEmail: process.env.NEXT_PUBLIC_PAYMENT_METHOD_REQUIRED_EMAIL === "true",
      requiredDocumentNumber: process.env.NEXT_PUBLIC_PAYMENT_METHOD_REQUIRED_DOCUMENT_NUMBER === "true"
    };
    return config;
  }
}

// Export singleton instance
PermissionsManager.instance = void 0;
export const permissionsManager = PermissionsManager.getInstance();